export type PlaceCategory = 'municipal' | 'sport' | 'culture' | 'parc' | 'ecocentre'

export interface Place {
  id: string
  name: string
  category: PlaceCategory
  address: string
  note: string
  open: boolean
  lat: number
  lng: number
}

export const placeCategories: Record<PlaceCategory, { label: string; color: string }> = {
  municipal: { label: 'Town services', color: '#005151' },
  sport: { label: 'Sports and recreation', color: '#b45309' },
  culture: { label: 'Culture', color: '#8a6212' },
  parc: { label: 'Parks', color: '#3f6212' },
  ecocentre: { label: 'Waste and recycling', color: '#0f766e' },
}

export const cityCenter: [number, number] = [54.2704, -110.7369]

export const places: Place[] = [
  {
    id: 'town-office',
    name: 'Bonnyville Town Office',
    category: 'municipal',
    address: '4917 - 49 Avenue',
    note: 'Opens Monday 8:30 a.m.',
    open: false,
    lat: 54.2771,
    lng: -110.7316,
  },
  {
    id: 'library',
    name: 'Bonnyville Municipal Library',
    category: 'culture',
    address: '49 Avenue',
    note: 'Closes at 8 p.m.',
    open: true,
    lat: 54.273,
    lng: -110.7427,
  },
  {
    id: 'pool',
    name: 'Bonnyville Swimming Pool',
    category: 'sport',
    address: '50 Avenue',
    note: 'Closed for annual maintenance',
    open: false,
    lat: 54.2678,
    lng: -110.7457,
  },
  {
    id: 'centennial-centre',
    name: 'Bonnyville and District Centennial Centre',
    category: 'sport',
    address: '49 Avenue',
    note: 'Closes at 10 p.m.',
    open: true,
    lat: 54.2736,
    lng: -110.7266,
  },
  {
    id: 'seniors-centre',
    name: 'Bonnyville Seniors Drop-In Centre',
    category: 'culture',
    address: '50 Avenue',
    note: 'Opens Monday 8 a.m.',
    open: false,
    lat: 54.2745,
    lng: -110.7445,
  },
  {
    id: 'jessie-lake',
    name: 'Jessie Lake Trail',
    category: 'parc',
    address: 'Lakeshore Drive',
    note: 'Open 6 a.m. to 11 p.m.',
    open: true,
    lat: 54.2691,
    lng: -110.7316,
  },
  {
    id: 'lakeshore-park',
    name: 'Lakeshore Drive Park',
    category: 'parc',
    address: 'Lakeshore Drive',
    note: 'Playground and spray park',
    open: true,
    lat: 54.273,
    lng: -110.7424,
  },
  {
    id: 'skate-park',
    name: 'Bonnyville Skate Park',
    category: 'parc',
    address: '44 Street',
    note: 'Outdoor rink in winter',
    open: true,
    lat: 54.2642,
    lng: -110.7388,
  },
  {
    id: 'transfer-station',
    name: 'Bonnyville Transfer Station',
    category: 'ecocentre',
    address: 'Highway 41',
    note: 'Opens Saturday 9 a.m.',
    open: false,
    lat: 54.262,
    lng: -110.7247,
  },
  {
    id: 'recycling-compound',
    name: 'Recycling Compound',
    category: 'ecocentre',
    address: '49 Avenue',
    note: 'Yard waste and brush',
    open: true,
    lat: 54.2775,
    lng: -110.747,
  },
  {
    id: 'rcmp',
    name: 'Bonnyville RCMP Detachment',
    category: 'municipal',
    address: '50 Avenue',
    note: 'Open 24 h',
    open: true,
    lat: 54.2658,
    lng: -110.7316,
  },
  {
    id: 'parent-child-centre',
    name: 'Parent Child Centre',
    category: 'culture',
    address: '46 Street',
    note: 'Closes at 4:30 p.m.',
    open: true,
    lat: 54.279,
    lng: -110.7377,
  },
]
